import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../../App.css';
import './RecuperarSenhaPage.css';
import logo from '../../assets/img/logo-header.png';
import ResetTokenService from '../../services/PasswordResetTokenService';
import { validarLogin } from '../../utils/validators';

export default function RedefinirSenhaPage() {

  const [email, setEmail] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [carregando, setCarregando] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setSucesso('');

    if (!email) {
      setErro('Informe o email.');
      return;
    }

    if (!validarLogin(email)) {
      setErro('Email inválido.');
      return;
    }

    try {
      setCarregando(true);
      await ResetTokenService.solicitar(email);
      setSucesso(
        'Enviamos um E-mail com as instruções para redefinir a senha.'
      );
      setEmail('');

    } catch (error) {
      setErro('Erro ao solicitar redefinição de senha.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="reset-container">

      <form className="reset-form" onSubmit={handleSubmit}>
        <img src={logo} alt="Logotipo" />
        <h2>REDEFINIR SENHA</h2>

        <input
          className="reset-inputs"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email cadastrado"
        />

        <button type="submit" disabled={carregando}>
          {carregando ? 'Enviando...' : 'Enviar'}
        </button>

        {erro && <p className="erro-msg">{erro}</p>}
        {sucesso && <p className="sucesso-msg">{sucesso}</p>}

        <button className="reset-link voltar" onClick={() => navigate('/Login')}>
          Voltar ao login
        </button>
      </form>

    </div>
  );
}
